import { useState, useEffect, useCallback } from 'react';
import { getJobCostOverview } from '../api/jobCostOverview';
import type { JobCostOverviewDto } from '../types/jobCostOverview';

export function useJobCostOverview(jobId: number) {
  const [data, setData] = useState<JobCostOverviewDto | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const overview = await getJobCostOverview(jobId);
      setData(overview);
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to fetch cost overview');
      setData(null);
    } finally {
      setIsLoading(false);
    }
  }, [jobId]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    data,
    isLoading,
    error,
    refetch: fetch,
  };
}
